<template>
  <div id="myModal" class="modal">

  <!-- Modal content -->

  <div class="modal-content">
    <span v-on:click="close" class="close">&times;</span>
    <div class="headerWrap">
      <div class="resavationText">
        Ny booking
      </div>
      <div class="dateText">
        <!-- Onsdag - 20 November 2018 -->
        {{computedSelectionDay.weekdayname}} {{computedSelectionDay.weekday}} {{computedSelectionDay.date}} {{computedSelectionDay.month}} {{computedSelectionDay.year}}
      </div>
    </div>
    <div class="timeSelectorWrap">
      <div class="timerWrap">
        <div class="clockWrap hours">
          <button v-on:click="changeHour('+', 'start')" class="iconWrapPlus">
            <icon class="iconClass" name="angle-up" v-bind:scale="iconScale"></icon>
          </button>
          <button v-on:click="changeHour('-', 'start')" class="iconWrapMinus">
            <icon class="iconClass" name="angle-down" v-bind:scale="iconScale"></icon>
          </button>
          {{bookingTimeComputed.startHour}}
        </div>
        <div class="colon">
          :
        </div>
        <div class="clockWrap minutes">
          <button v-on:click="changeMinutes('+', 'start')" class="iconWrapPlus">
            <icon class="iconClass" name="angle-up" v-bind:scale="iconScale"></icon>
          </button>
          <button v-on:click="changeMinutes('-', 'start')" class="iconWrapMinus">
            <icon class="iconClass" name="angle-down" v-bind:scale="iconScale"></icon>
          </button>
          {{bookingTimeComputed.startMinutes}}
        </div>
        -
        <div class="clockWrap hours">
          <button v-on:click="changeHour('+', 'end')" class="iconWrapPlus">
            <icon class="iconClass" name="angle-up" v-bind:scale="iconScale"></icon>
          </button>
          <button v-on:click="changeHour('-', 'end')" class="iconWrapMinus">
            <icon class="iconClass" name="angle-down" v-bind:scale="iconScale"></icon>
          </button>
          {{bookingTimeComputed.endHour}}
        </div>
        <div class="colon">
          :
        </div>
        <div class="clockWrap minutes">
          <button v-on:click="changeMinutes('+', 'end')" class="iconWrapPlus">
            <icon class="iconClass" name="angle-up" v-bind:scale="iconScale"></icon>
          </button>
          <button v-on:click="changeMinutes('-', 'end')" class="iconWrapMinus">
            <icon class="iconClass" name="angle-down" v-bind:scale="iconScale"></icon>
          </button>
          {{bookingTimeComputed.endMinutes}}
        </div>

      </div>
      <!-- <div v-on:click="clickTest" class="iconWrap">
        <icon class="iconClass" name="plus-circle" v-bind:scale="iconScale"></icon>
      </div> -->
    </div> <!--End of timeSelectorWrap -->
    <button v-on:click="bookIt" class="btnReserver">
      Book tid
    </button>
  </div>
  <transition name="fade">
    <info-modal v-if="showModal" @close="showModal = false">
      <div slot="body">{{modalInfoText}}</div>
    </info-modal>
  </transition>
</div>
</template>

<script>
import bus from '@/bus.js'
import { db } from '@/firebase'
import infoModal from '@/components/infoModal.vue'

export default {
  props: ['computedSelectionDay', 'selectedDateRecived', 'machineSelection', 'firebooking', 'fireSettings'],
  data () {
    return {
      bookingTime: {startHour: 12, startMinutes: 0, endHour: 13, endMinutes: 0},
      iconScale: 1.8,
      showModal: false,
      modalInfoText: 'test',
    }
  },
  components: {
    'info-modal': infoModal
  },
  methods: {
    close() {
      bus.$emit('closeModal', 'close')
    },
    changeHour(plusMinus, startEnd) {
      let start = this.bookingTime.startHour
      let end = this.bookingTime.endHour
      if(plusMinus == '+'){
        if (startEnd == 'start') {
          if (start >= 23 ) {
            return
          } else {
            start = start + 1

          }
        } else if (startEnd == 'end') {
          if (end == 24 ) {
            this.bookingTime.endMinutes = 0
            return
          } else {
            end = end + 1
            if(end == 24){
              this.bookingTime.endMinutes = 0
            }
          }
        }
      } else if (plusMinus == '-') {
        if (startEnd == 'start') {
          if (start == 1) {
            start = 1
          } else {
            start = start - 1
          }
        } else if (startEnd == 'end') {
          if (end == 1) {
            end = 1
          } else {
            end = end - 1
          }
        }
      }
      this.bookingTime.startHour = start
      this.bookingTime.endHour = end
    },
    changeMinutes(plusMinus, startEnd) {
      let start = this.bookingTime.startMinutes
      let end = this.bookingTime.endMinutes
      if(plusMinus == '+'){
        if (startEnd == 'start') {
          if (start == 45) {
            start = 0
          } else {
            start = start + 15
          }
        } else if (startEnd == 'end') {
          if (end == 45) {
            end = 0
          } else {
            end = end + 15
          }
        }
        if (this.bookingTime.endHour == 24 ) {
          end = 0
        }
      } else if (plusMinus == '-') {
        if (startEnd == 'start') {
          if (start == 0) {
            start = 45
          } else {
            start = start - 15
          }
        } else if (startEnd == 'end') {
          if (end == 0) {
            end = 45
          } else {
            end = end - 15
          }
        }
        if (this.bookingTime.endHour == 24 ) {
          end = 0
        }
      }
      this.bookingTime.startMinutes = start
      this.bookingTime.endMinutes = end

    },
    bookIt(){
      // bus.$emit('bookingTime', this.bookingTime)
      this.addBookingOld()
      // bus.$emit('closeModal', 'close')
      // alert('Book it: ' + this.bookingTime)
    },
    addBookingOld() {
      // alert('User ID ' + this.$activeUserId)
      let tStart = new Date(this.selectedDateRecived.getTime()) //Til prop
      let tEnd = new Date(this.selectedDateRecived.getTime()) //Til prop
      let openTime = new Date(this.selectedDateRecived.getTime())
      let closeTime = new Date(this.selectedDateRecived.getTime())
      const startHour = this.bookingTime.startHour
      const startMinutes = this.bookingTime.startMinutes
      const endHour = this.bookingTime.endHour
      const endMinutes = this.bookingTime.endMinutes
      const ownerID = this.$activeUserId
      const laundryRoom = this.$laundryRoom
      const machineType = this.machineSelection //Til prop
      const openHour = this.fireSettings.startHour
      const openMinutes = this.fireSettings.startMinutes
      const closeHour = this.fireSettings.endHour
      const closeMinutes = this.fireSettings.endMinutes
      let bookingObject = {start: 0, end: 0, owner: '', machine: ''}
      let ownerText = ''
      tStart.setHours(startHour)
      tStart.setMinutes(startMinutes)
      tStart.setSeconds(0)
      tStart.setMilliseconds(0)
      tEnd.setHours(endHour)
      if (endHour == 24){
        tEnd.setMinutes(endMinutes -1)
      } else {
        tEnd.setMinutes(endMinutes)
      }
      tEnd.setSeconds(0)
      tEnd.setMilliseconds(0)
      //Convert opening hours into milliseconds since 1970
      openTime.setHours(openHour)
      openTime.setMinutes(openMinutes)
      openTime.setSeconds(0)
      openTime.setMilliseconds(0)
      closeTime.setHours(closeHour)
      closeTime.setMinutes(closeMinutes)
      closeTime.setSeconds(0)
      closeTime.setMilliseconds(0)

      //Adding ownerText (apartment), if it exsists in under user/{serID}
      if (this.$apartment){
        ownerText = this.$apartment
      } else {
        let fullUserName = this.$nameOfUser
        let fullUserNameArray = fullUserName.split(" ")
        ownerText = fullUserNameArray[0]
      }

      bookingObject = {start: tStart.getTime(), end: tEnd.getTime(), owner: ownerID, machine: machineType, ownerText: ownerText, openTime: openTime, closeTime: closeTime}
      this.checkForBooking(bookingObject, laundryRoom)
      // db.ref('laundryrooms/' + laundryRoom + '/bookings/').push(bookingObject)
      // console.log('Booking object: ' + bookingObject.start + ' ' + bookingObject.end + ' ' + bookingObject.owner);
      // console.log(laundryRoom);
      // console.log('selected = ' + this.selectedDateRecived);
      // db.ref(this.$hotelId +'/boxes/').set(updatedData)
    },
    checkForBooking(newBooking, laundryRoom) {
      const existingBookings = this.firebooking
      if (existingBookings) {
      }
      for (var booking in existingBookings) {
        if (existingBookings[booking].machine == newBooking.machine)
        {
        if (
          //new start time not in interval
          newBooking.start > existingBookings[booking].start &&
          newBooking.start < existingBookings[booking].end ||
          //new end time not in interval
          newBooking.end > existingBookings[booking].start &&
          newBooking.end < existingBookings[booking].end ||
          //existing booking not in interval of new booking
          newBooking.start < existingBookings[booking].start &&
          newBooking.end > existingBookings[booking].end ||
          //new booking end time not qual to existing booking end
          //time while new booking start time is less than existing booking start
          newBooking.start < existingBookings[booking].start &&
          newBooking.end == existingBookings[booking].end ||

          newBooking.start == existingBookings[booking].start &&
          newBooking.end > existingBookings[booking].end ||

          newBooking.start == existingBookings[booking].start &&
          newBooking.end == existingBookings[booking].end
        ){
          this.showModal = true
          this.modalInfoText = 'Eksisterende booking'
          // alert('Existing booking!')
          return
        }//end of if
        }
      }
      if (
        newBooking.start > newBooking.end ||
        newBooking.start == newBooking.end
      ) {
        this.showModal = true
        this.modalInfoText = 'Den valgte tid er ikke gyldig'
        // alert('Selected booking time not valid!')
        return
      }//end of if
      if (
        newBooking.start < newBooking.openTime ||
        newBooking.end > newBooking.closeTime
      ) {
        this.showModal = true
        this.modalInfoText = 'Den valgte tid er udenfor åbningstiden'
        // alert('Selected booking time not valid!')
        return
      }
      db.ref('laundryrooms/' + laundryRoom + '/bookings/').push(newBooking)
      bus.$emit('closeModal', 'close')
    }//end of checkForBooking
  },
  computed: {
    bookingTimeComputed: function() {
      let startHour = this.bookingTime.startHour.toString()
      let startMinutes = this.bookingTime.startMinutes.toString()
      let endHour = this.bookingTime.endHour.toString()
      let endMinutes = this.bookingTime.endMinutes.toString()

      if (startHour.length == 1) {
        startHour = '0' + startHour
      }
      if (startMinutes.length == 1) {
        startMinutes = '0' + startMinutes
      }
      if (endHour.length == 1) {
        endHour = '0' + endHour
      }
      if (endMinutes.length == 1) {
        endMinutes = '0' + endMinutes
      }

      const bookingTime = {
        startHour: startHour,
        startMinutes: startMinutes,
        endHour: endHour,
        endMinutes: endMinutes
      }
      return bookingTime
    }
  }
}


</script>

<style scoped>
* {
  box-sizing: border-box;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

button {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
}

/* The Modal (background) */
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  position: relative;
  border-radius: 4px;
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  /* border: 1px solid #888; */
  width: 80%;
  max-width: 450px;
  min-width: 300px;
}

/* Header */
.headerWrap {
  margin: 16px 0px;
}

.resavationText {
  font-size: 1.7rem;
  font-weight: 400;
  color: rgba(0,0,0,0.8);
  margin-bottom: 5px;
}

.dateText {
  font-size: 0.8rem;
  color: rgba(0,0,0,0.6);
}

/* time selection */
.timeSelectorWrap {
  margin-top: 50px;
  margin-bottom: 50px;
}
.timerWrap {
  /* background-color: orange; */
  font-size: 1.5rem;
  font-weight: bold;
  width: 250px;
  height: 50px;
  line-height: 50px;
  margin: 0 auto;
  border: 1px solid rgba(0,0,0,0.3);
  border-radius: 4px;
  color: rgba(0,0,0,0.8);
}

.clockWrap {
  width: 30px;
  display: inline-block;
  position: relative;
}
.hours {
  text-align: center;
  margin-right: -5px;
}
.minutes {
  text-align: center;
  margin-left: -5px;
}
.iconWrapPlus {
  cursor: pointer;
  width: 30px;
  position: absolute;
  top: -40px;
  color: rgba(0,0,0,0.4);
  /* left: 6px; */
}

.iconWrapMinus {
  cursor: pointer;
  width: 30px;
  position: absolute;
  top: 45px;
  color: rgba(0,0,0,0.4);
  /* left: 6px; */
}

.colon {
  display: inline-block;
}

/* The Close Button */
.close {
  top: 0px;
  right: 12px;
  position: absolute;
  color: #aaaaaa;
  /* float: right; */
  font-size: 35px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.btnReserver {
  cursor: pointer;
  font-weight: bold;
  font-size: 1.4rem;
  color: white;
  border-radius: 4px;
  height: 40px;
  line-height: 40px;
  /* background-color: #54bf67; */
  background-color: #00BAE0;
  margin: 0 auto;
  width: 250px;
}


</style>



// WEBPACK FOOTER //
// src/components/reservationModal.vue